module.exports = __webpack_public_path__ + "img/9788954613309.6605a75e.jpg";